"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTime = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var constants_1 = require("../constants");
var MAX_VISIBLE_ITEMS_COUNT = 5;
var DateTime = /** @class */ (function (_super) {
    tslib_1.__extends(DateTime, _super);
    function DateTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.timeChange = function (selectedTime) {
            _this.props.onTimeChange({
                hour: selectedTime.getHours(),
                minute: selectedTime.getMinutes(),
                second: selectedTime.getSeconds(),
            });
        };
        return _this;
    }
    DateTime.prototype.render = function () {
        var _a = this.props, date = _a.date, dateFormat = _a.dateFormat, label = _a.label, locale = _a.locale, timezone = _a.timezone, onDateChange = _a.onDateChange;
        return (React.createElement("div", { className: "gd-input-component gd-schedule-email-dialog-datetime s-gd-schedule-email-dialog-datetime" },
            React.createElement("label", { className: "gd-label" }, label),
            React.createElement("div", null,
                React.createElement(sdk_ui_kit_1.Datepicker, { date: date, dateFormat: dateFormat, locale: locale, placeholder: dateFormat, resetOnInvalidValue: true, onChange: onDateChange }),
                React.createElement(sdk_ui_kit_1.Timepicker, { className: "gd-schedule-email-dialog-datetime-time", maxVisibleItemsCount: MAX_VISIBLE_ITEMS_COUNT, skipNormalizeTime: true, time: date, onChange: this.timeChange, overlayPositionType: "sameAsTarget", overlayZIndex: constants_1.DEFAULT_DROPDOWN_ZINDEX }),
                React.createElement("span", { className: "gd-schedule-email-dialog-datetime-timezone s-gd-schedule-email-dialog-datetime-timezone" }, timezone))));
    };
    return DateTime;
}(React.PureComponent));
exports.DateTime = DateTime;
//# sourceMappingURL=DateTime.js.map